var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNewSearchFinance = function SvgNewSearchFinance(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.47543e-08 5.81882C0.000207747 6.96942 0.341588 8.09412 0.980979 9.05071C1.62037 10.0073 2.52904 10.7528 3.59212 11.193C4.6552 11.6332 5.82493 11.7482 6.95339 11.5236C8.08186 11.299 9.11839 10.7448 9.93191 9.93118C10.7454 9.11751 11.2994 8.08088 11.5238 6.95237C11.7482 5.82386 11.6329 4.65416 11.1926 3.59116C10.7522 2.52816 10.0065 1.61962 9.04983 0.980398C8.09313 0.34118 6.96835 1.87378e-08 5.81775 0C5.05366 -1.24433e-08 4.29707 0.150515 3.59116 0.442951C2.88525 0.735387 2.24385 1.16402 1.7036 1.70436C1.16336 2.2447 0.734855 2.88616 0.442547 3.59213C0.150238 4.29809 -0.000137802 5.05473 9.47543e-08 5.81882ZM9.97451 5.81882C9.97472 6.64099 9.7311 7.44476 9.27448 8.12847C8.81785 8.81218 8.16873 9.34512 7.40921 9.6599C6.64968 9.97467 5.81386 10.0571 5.00746 9.89687C4.20106 9.7366 3.4603 9.34079 2.87887 8.7595C2.29743 8.17821 1.90144 7.43755 1.74096 6.63119C1.58049 5.82484 1.66274 4.989 1.97732 4.22939C2.2919 3.46978 2.82469 2.82053 3.50828 2.36373C4.19188 1.90693 4.99558 1.66312 5.81775 1.66312C6.92001 1.66312 7.97714 2.10092 8.75665 2.88023C9.53616 3.65954 9.97423 4.71656 9.97451 5.81882Z",
    fill: "#B5B5C3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79834 9.80078L13.9981 14.0006",
    stroke: "#B5B5C3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNewSearchFinance, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/new-search-finance.4bdf1e09.svg";
export { ForwardRef as ReactComponent };